import type { MessageDesignTokens, MessageTokenSections } from '@openng/optimus-ui-themes/types/message';

export const closeButton: MessageTokenSections.CloseButton = {
	borderRadius: '{message.close.button.width} / 2',
};

export const colorScheme: MessageTokenSections.ColorScheme = {
	light: {
		info: {
			background: 'color-mix(in srgb, {primary.50}, transparent 5%)',
			borderColor: '{primary.200}',
			color: '{primary.600}',
			shadow: '0px 4px 8px 0px color-mix(in srgb, {primary.500}, transparent 96%)',
			closeButton: {
				hoverBackground: '{primary.100}',
				focusRing: {
					color: '{primary.600}',
				},
			},
			outlined: {
				color: '{primary.600}',
				borderColor: '{primary.600}',
			},
			simple: {
				color: '{primary.600}',
			},
		},
	},
};

export default {
	closeButton,
	colorScheme,
} satisfies MessageDesignTokens;
